// DS6.7.1
import React from 'react';
import classnames from 'classnames';
import Tag from './Tag';
import RemovableTag from './RemovableTag';
import s from './TagList.scss';
var TagList = React.forwardRef(function (props, ref) {
    var tags = props.tags, _a = props.size, size = _a === void 0 ? 'medium' : _a, multiline = props.multiline, isTruncated = props.isTruncated, className = props.className, children = props.children;
    return (React.createElement("div", { className: classnames(s['root'], s["size-".concat(size)], !multiline && s['scrollable'], className), ref: ref },
        tags.map(function (_a) {
            var tagname = _a.tagname, href = _a.href, isRemovable = _a.isRemovable, isSelected = _a.isSelected, biData = _a.biData, tagClassName = _a.className, onClick = _a.onClick;
            var TagItem = isRemovable ? RemovableTag : Tag;
            return (React.createElement(TagItem, { key: tagname, size: size, href: href, isSelected: isSelected, onClick: onClick, biData: biData, isTruncated: isTruncated, className: classnames(s['tag-item'], tagClassName) }, tagname));
        }),
        children));
});
TagList.displayName = 'TagList';
export default TagList;
//# sourceMappingURL=TagList.js.map